import sanitizeHtml from 'sanitize-html';

export const STORES_HOSTS = [
    'play.google.com',
    'chrome.google.com',
    'apps.apple.com',
    'appgallery.huawei.com',
];
export const SHORTLINK_HOSTS = ['goo.gl', 'bitly.com', 'alipromo.com', 'alii.pub', 'epnclick.ru'];

export const SOCIAL_HOSTS = [
    'vk.com',
    'ok.ru',
    'odnoklassniki.ru',
    'facebook.com',
    'fb.me',
    'youtube.com',
    'pinterest.com',
    'twitter.com',
    'tumblr.com',
    'instagram.com',
    'new.vk.com',
    'm.vk.com',
    'm.ok.ru',
    'm.facebook.com',
    'plus.google.com',
    'lm.facebook.com',
    'youtube.ru',
    'vk.ru',
    'ru.pinterest.com',
    'vk.co',
    'telegram.org',
    'vkontakte.ru',
];

export const SOCIAL_HOSTS_WITH_PATH = [
    'ok.ru/feed',
    'vk.com/feed',
    'vk.com/feed?section=notifications',
    'ok.ru/feed?st.cmd=userMain',
    'vk.com/groups',
    'vk.com/video',
    'vk.com/settings',
    'vk.com/search',
    'm.vk.com',
    'm.vk.com/feed',
    'm.vk.com/friends',
    'm.vk.com/groups',
    'm.vk.com/search',
    'm.vk.com/settings',
    'ok.ru/notifications',
    'ok.ru/guests',
    'm.facebook.com/home.php',
    'twitter.com/settings/account',
    'vk.com/al_feed.php',
    'tumblr.com/dashboard',
];

export const getPlacementsColumns = (
    t: (key: string) => string,
): { title: string; dataIndex: string; textAlign: string; maxWidth?: number; key: string }[] => {
    return [
        {
            title: t('Offer'),
            dataIndex: 'offerId',
            textAlign: 'left',
            key: 'offers',
        },
        {
            title: t('Traffic source'),
            dataIndex: 'trafficSourceId',
            textAlign: 'left',
            key: 'traffic source',
        },
        {
            title: t('Link'),
            dataIndex: 'link',
            textAlign: 'left',
            key: 'link',
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            textAlign: 'left',
            key: 'status',
        },
        {
            title: t('Comment'),
            dataIndex: 'parsedComment',
            key: 'parsedComment',
            textAlign: 'left',
        },
        {
            title: t('Actions'),
            dataIndex: 'actions',
            textAlign: 'right',
            key: 'actions',
        },
    ];
};

export const getPlacementsStatusWithTranslate = (
    t: (key: string) => string,
    status: string,
): string => {
    const STATUS_MAP = {
        waiting: t('Waiting status'),
        allow: t('Allowed status'),
        review: t('on review status'),
        recheck: t('on review status'),
        ban: t('Declined status'),
    };

    return STATUS_MAP[status] || status;
};

export const getPlacementsStatusColor = (status: string): string => {
    const COLORS_MAP = {
        waiting: 'blue-500',
        allow: 'green-500',
        review: 'blueGray-500',
        recheck: 'blueGray-500',
        ban: 'red-500',
    };

    return COLORS_MAP[status] || status;
};

export const PLACEMENTS_DEFAULT_PARAMS = {
    statuses: 'allow,waiting,review,recheck,ban',
    fields: 'id,title,url,status,offer_id,comment,traffic_source_id',
    limit: 7,
    offset: 0,
};

export const COMMENT_SANITIZE_OPTIONS: sanitizeHtml.IOptions = {
    allowedTags: ['b', 'i', 'em', 'strong', 'a'],
    allowedAttributes: {
        a: ['href', 'class'],
    },
    allowedIframeHostnames: ['www.youtube.com'],
    transformTags: {
        a: sanitizeHtml.simpleTransform('a', { class: 'underline' }),
    },
};
